export default __webpack_public_path__ + "static/media/AttachmentActive.aef41cd3.svg";